export default __webpack_public_path__ + "static/media/1954.606d3fd9.png";